/**
 * @param {string|null|undefined} iso
 * @param {number} nowMs
 * @returns {number|null}
 */
export function msSinceIso(iso, nowMs) {
  if (iso == null || iso === "") return null;
  const parsed = Date.parse(iso);
  if (Number.isNaN(parsed)) return null;
  return Math.max(0, nowMs - parsed);
}

/**
 * @param {number|null|undefined} ms
 * @param {(key: string, opts?: object) => string} tLive - settings namespace (`dashboardPage.live.*`)
 */
export function formatTeamPresenceAge(ms, tLive) {
  if (ms == null || !Number.isFinite(ms)) return "—";
  const s = Math.floor(ms / 1000);
  if (s < 60) return tLive("dashboardPage.live.teamPresenceDurationSec", { n: s });
  const m = Math.floor(s / 60);
  if (m < 60) return tLive("dashboardPage.live.teamPresenceDurationMin", { n: m });
  const h = Math.floor(m / 60);
  return tLive("dashboardPage.live.teamPresenceDurationHour", { n: h });
}
